<script lang="ts">
import { CommandI3pService } from '~/services/commands.i3p.service'
import CommandsI3p from '~/components/I3pComponent/I3p.vue'
import { BaseRoutesEnum } from '~/enum/BaseRoutes.enum'
import { useConfigStore } from '~/store'

export default {
    name: 'Commandes',
    components: {
        CommandsI3p,
    },
    setup() {
        useHead({
            title: 'Commandes',
            meta: [
                { name: 'description', content: 'Commandes' },
            ],
        })
        definePageMeta({
            middleware: ['auth'],
        })
    },
    data() {
        const configStore = useConfigStore()
        return {
            configStore,
            baseUrl: BaseRoutesEnum.commandes,
            commandI3pService: new CommandI3pService(),
        }
    },
    computed: {
        isApplicationServiceReady(): boolean {
            return !!this.configStore?.currentConfig?.app_info
        },
    },
}
</script>

<template>
    <CommandsI3p v-if="isApplicationServiceReady" :i3p-service="commandI3pService" :base-url />
</template>
